<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <h2 class="col-12">
            {{$t('transfert.transfert_client_management')}}
            <hr>
        </h2>
        <h6 class="col-12" style="padding-top: 0;margin-top: 0;">
            Transférer de l'argent à un utilisateur intram depuis votre portefeuille
        </h6>
        <div class="col-12 mb-4">
            <v-card>

            <div>
                <template >
                    <v-toolbar flat color="white">
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog" max-width="800px">
                            <template v-slot:activator="{ on }">
                                <v-btn style="margin-top: 1%" v-if="$store.getters.auth.role._code!=='admin'" color="default" dark class="mb-2" v-on="on">{{$t('add_transfert')}}</v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <v-col md="11" lg="11" sm="11">
                                        <span class="headline">  {{ formTitle }} </span>
                                    </v-col>
                                    <v-col md="1" lg="1" sm="1">
                                        <v-icon style="cursor: pointer" @click="setdefaultClose()" > mdi-close  </v-icon>
                                    </v-col>
                                </v-card-title>

                                <v-card-text>
                                    <v-form ref="form" v-model="valid" :lazy-validation="lazy"  enctype="multipart/form-data">

                                        <v-stepper v-model="e1">
                                            <v-stepper-header>
                                                <v-stepper-step
                                                        :complete="e1 > 1"
                                                        step="1"
                                                >
                                                   Informations du transfert
                                                </v-stepper-step>

                                                <v-divider></v-divider>

                                                <v-stepper-step
                                                        :complete="e1 > 2"
                                                        step="2"
                                                >
                                                    Motif
                                                </v-stepper-step>
                                                <v-divider></v-divider>
                                                <v-stepper-step
                                                        :complete="e1 > 3"
                                                        step="3"
                                                >
                                                   Détails
                                                </v-stepper-step>


                                            </v-stepper-header>
                                            <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>

                                            <v-alert v-if="errors.operation" dense outlined type="error">
                                                {{errors.operation}}
                                            </v-alert>
                                            <v-stepper-items>
                                                <v-stepper-content step="1">
                                                    <v-container >
                                                       <v-col>
                                                            <h6>Utiliser l'email du recepteur de la transaction pour effectué un transfert instantanemant.</h6>
                                                        </v-col>
                                                        <v-row >
                                                            <v-col  v-if="editedItem._montant" cols="12" sm="6"
                                                                    md="12">
                                                                <v-alert cols="12" sm="6"
                                                                         md="12"
                                                                        color="primary"
                                                                        text
                                                                        border="top"
                                                                        transition="scale-transition">
                                                                    <v-row>

                                                                        <v-col cols="12" sm="3"
                                                                               md="3" style="font-weight: bold">
                                                                            {{$t("transfert.solde")}} : {{walle}} {{$store.getters.auth.wallet.devise._code_alpha}}
                                                                        </v-col>
                                                                        <v-col cols="12" sm="2"
                                                                               md="3" style="font-weight: bold">
                                                                            {{$t("recharges.ratenow")}} : {{generaldatas.tt}} %
                                                                        </v-col>

                                                                        <v-col cols="12" sm="3"
                                                                               md="2" style="font-weight: bold">
                                                                            {{$t("recharges.fees")}} : {{((parseFloat(editedItem._montant)*parseFloat(generaldatas.tt))/100)}} {{$store.getters.auth.wallet.devise._code_alpha}}

                                                                        </v-col>

                                                                        <v-col cols="12" sm="4"
                                                                               md="4" style="font-weight: bold">
                                                                            {{$t("recharges.net_amount")}} : {{(parseFloat(editedItem._montant)*parseFloat(generaldatas.tt))/100+parseFloat(editedItem._montant)}} {{$store.getters.auth.wallet.devise._code_alpha}}
                                                                        </v-col>


                                                                    </v-row>                                                                </v-alert>

                                                            </v-col>
                                                            <v-col cols="12" sm="12">
                                                                <v-form  ref="form" v-model="valid" :lazy-validation="lazy"  enctype="multipart/form-data">
                                                                    <v-container style="margin-top: 2%">
                                                                        <v-col cols="12" sm="12">
                                                                            <v-text-field   :rules="[montantRules.loanMin, montantRules.loanMaxMax,montantRules.loanMax, montantRules.required]" type="number" v-model="editedItem._montant" :label="$t('transfert.montant')" min="1000" clearable   ></v-text-field>
                                                                      <span>NB: La devise par défaut de votre compte marchand définis celui du montant inséré.</span>
                                                                        </v-col>

                                                                        <v-col cols="12" sm=12 >
                                                                            <v-text-field  v-if="$store.getters.marchand" :rules="[rules.required,rules.email]" type="email" v-model="editedItem._recepteur"  :label="$t('transfert.add_recepteur')" clearable ></v-text-field>
                                                                        <span>Exemple: client@gmail.com</span>
                                                                        </v-col>
                                                                    </v-container>
                                                                </v-form>
                                                            </v-col>

                                                        </v-row>

                                                    </v-container>

                                                    <div class="float-right">
                                                    <v-btn :disabled="!valid"
                                                           color="primary"
                                                           @click.prevent="suivant"
                                                    >
                                                        {{$t('marchand.continue')}}

                                                    </v-btn>
                                                    </div>

                                                </v-stepper-content>

                                                <v-stepper-content step="2">
                                                    <v-card-text>

                                                        <v-form  ref="form" v-model="valid" :lazy-validation="lazy"  enctype="multipart/form-data">
                                                            <v-container style="margin-top: 2%">
                                                                <v-col cols="12" sm="12" >
                                                                    <v-textarea
                                                                            :rules="reasonRules"
                                                                            v-model="editedItem._reason"
                                                                            single-line
                                                                            counter
                                                                            maxlength="50"
                                                                            :label="$t('transfert.reason_text')"
                                                                    ></v-textarea>
                                                                </v-col>
                                                            </v-container>
                                                        </v-form>
                                                    </v-card-text>

                                                    <div class="float-right">
                                                    <v-btn
                                                            class="dark"
                                                            @click="e1 = 1"
                                                    >
                                                        {{$t('marchand.retour')}}
                                                    </v-btn>
                                                    <v-btn :disabled="!editedItem._reason"
                                                           color="primary"
                                                           style="margin-left: 15px"
                                                           @click.prevent="suivant1"
                                                    >
                                                        {{$t('marchand.continue')}}

                                                    </v-btn>
                                                    </div>
                                                </v-stepper-content>
                                                <v-stepper-content step="3">
                                                    <v-card-text>

                                                                    <v-row v-if="receiver">
                                                                        <div v-if="receiver._email===$store.getters.auth._email">
                                                                            <v-col cols="12" sm="12"
                                                                                   md="12" class="text-lg-center" style="font-weight: bold;color: red">
                                                                                {{recep}}
                                                                            </v-col>
                                                                        </div>
                                                                        <div v-else>
                                                                            <v-row>

                                                                            <v-col cols="12" sm="12"
                                                                                   md="12" class="text-lg-center" style="font-weight: bold;font-size: 18px">
                                                                                DETAILS DU TRANSFERT
                                                                            </v-col>
                                                                            <v-col v-if="recep_first_name" cols="12" sm="6"
                                                                                   md="6" >
                                                                                <span >Nom : </span>{{recep_first_name}}
                                                                            </v-col>
                                                                            <v-col v-else cols="6" sm="6"
                                                                                   md="6" >
                                                                                <span style="font-weight: bold"> Nom : </span>---
                                                                            </v-col>
                                                                            <v-col  v-if="recep_last_name" cols="12" sm="6"
                                                                                    md="6" >
                                                                           <span style="font-weight: bold">
                                                                                Prénom :
                                                                           </span>{{recep_last_name}}
                                                                            </v-col>
                                                                            <v-col  v-else cols="6" sm="6"
                                                                                    md="6" >
                                                                            <span style="font-weight: bold">
                                                                                 Prénom :
                                                                            </span>
                                                                                ---
                                                                            </v-col>

                                                                            <v-col v-if="recep_email" cols="6" sm="6"
                                                                                   md="6" >
                                                                            <span style="font-weight: bold">
                                                                               Email :
                                                                            </span>
                                                                                {{recep_email}}

                                                                            </v-col>
                                                                            <v-col v-else cols="6" sm="6"
                                                                                   md="6" >
                                                                            <span style="font-weight: bold">
                                                                               Email :
                                                                            </span> ---

                                                                            </v-col>

                                                                            <v-col cols="6" sm="6"
                                                                                   md="6" >
                                                                            <span style="font-weight: bold">
                                                                               Montant  :
                                                                            </span> {{editedItem._montant}} {{$store.getters.auth.wallet.devise._code_alpha}}
                                                                            </v-col>
                                                                            <v-col cols="6" sm="6"
                                                                                   md="6" >
                                                                            <span style="font-weight: bold">
                                                                                {{$t("recharges.fees")}} :
                                                                            </span> {{((parseFloat(editedItem._montant)*parseFloat(generaldatas.tt))/100)}} {{$store.getters.auth.wallet.devise._code_alpha}}

                                                                            </v-col>

                                                                            <v-col cols="6" sm="6"
                                                                                   md="6" >
                                                                            <span style="font-weight: bold">
                                                                                {{$t("recharges.net_amount")}} :
                                                                            </span>{{((parseFloat(editedItem._montant)*parseFloat(generaldatas.tt))/100)+parseFloat(editedItem._montant)}} {{$store.getters.auth.wallet.devise._code_alpha}}
                                                                            </v-col>
                                                                            <v-col cols="12" sm="12"
                                                                                   md="12" style="text-align: center" >
                                                                        <span style="font-weight: bold;">
                                                                             Motif :
                                                                        </span>
                                                                            </v-col>
                                                                            <v-col cols="12" sm="12"
                                                                                   md="12" >
                                                                                {{editedItem._reason}}
                                                                            </v-col>
                                                                            </v-row>
                                                                        </div>

                                                                    </v-row>
                                                                    <v-row v-else>
                                                                        <v-col cols="12" sm="12"
                                                                               md="12" class="text-lg-center" style="font-weight: bold;color: red">
                                                                            {{recep}}
                                                                        </v-col>

                                                                    </v-row>

                                                    </v-card-text>

                                                    <div class="float-right">
                                                    <v-btn
                                                            class="dark"
                                                            @click="e1 = 2"
                                                    >
                                                        {{$t('marchand.retour')}}
                                                    </v-btn>
                                                    <v-btn style="margin-left: 15px"  :disabled="mis || auth" class="primary" @click.prevent="save">Envoyer</v-btn>
                                                        </div>
                                                </v-stepper-content>


                                            </v-stepper-items>
                                        </v-stepper>

                                    </v-form>
                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
            </div>
                <div>
                    <v-tabs  v-model="tabs" color="primary" grow >
                        <v-tab>
                             Envoyé
                        </v-tab>
                        <v-tab>
                            Réçu
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tabs">
                        <!--NOTIFICATION -->
                        <v-tab-item>
                            <v-card flat>
                                <TransfertEnvoyer></TransfertEnvoyer>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <TransfertRecu ></TransfertRecu>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </v-card>
            <customsnackbar :snackbar="customSnack.snackbar"
                            :text="customSnack.text"
                            :snackcolor="customSnack.snackcolor" :snackbBtnColor="customSnack.snackbBtnColor"
                            :snacktimeout="customSnack.snacktimeout" > </customsnackbar>
        </div>
    </div>
</template>
<script>
    import {mapState} from "vuex";
    import TransfertRecu from "./TransfertRecu";
    import TransfertEnvoyer from "./TransfertEnvoyer";
    import helpers from "../../../../mixins/helpers";

    export default {
        name: "TransferGeneral",
        mixins:[helpers(this)],
        components: {TransfertEnvoyer, TransfertRecu},
        data () {
            return {
                submitting:false,
                valid:true,
                lazy:false,
                mis:false,
                auth:false,
                items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
                errors:{},
                transfers_envoyes: [],
                search: '',
                e1: 1,
                customSnack:{
                    snackbar: false,
                    text: "",
                    snackcolor:"black",
                    snackbBtnColor:"white",
                    snacktimeout:2000
                },
                recep_first_name:'',
                recep_last_name:'',
                recep_email:'',
                recep:'',
                tabs: null,
                dialog: '',
                step1: false,
                step2: false,
                generaldatas:{},
                step3: true,
                walle:0,
                id:undefined,
                categorieHasChanged:false,
                headers: [
                    {
                        text: this.$t('transfert.type'),
                        align: 'start',
                        sortable: false,
                        value: '_type',
                    },
                    {text: this.$t('transfert.sender'), value: 'sender_user._email'},
                    {text: this.$t('transfert.recepteur'), value: 'receiver_user._email'},
                    {text: this.$t('transfert.montant'), value: '_amount'},
                    {text: this.$t('transfert.reason'), value: '_reason'},
                    {text: this.$t('date'), value: '_created_at'},

                ],
                editedIndex: -1,
                editedItem: {
                    _montant: '',
                    _recepteur: '',
                    _net: '',
                    _reason: '',
                    _created_at: 0,
                    _id:''
                },
                defaultItem: {
                    _montant: '',
                    _recepteur: '',
                    _reason: '',
                    _net: '',
                    _created_at: 0,
                    _id:''
                },
                recepteurRules: [
                    v => !!v || this.$t('transfert.requis_recepteur'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                reasonRules: [
                    v => !!v || this.$t('transfert.requis_reason'),
                ],
                montantRules: {
                    required: v => !!v || this.$t('transfert.requis_montant'),
                    loanMin: v => v >=parseFloat(this.generaldatas.mmintr) || 'Veuillez entrer le montant minimum de transfert. Montant >='+this.generaldatas.mmintr,
                    loanMax: v => v <=parseFloat(this.generaldatas.mmaxtr) || 'Le montant que vous aviez entré depassé le montant maximum de transfert. Montant <='+this.generaldatas.mmaxtr,
                    loanMaxMax: v => (parseFloat(v)*parseFloat(this.generaldatas.tt))/100+parseFloat(v) <= this.walle || `Votre solde est inférieur au  montant net du transfert.`,
                },
                rules: {
                    required: value => !!value ||  'Entrer l\'émail du receptuer',
                    min: v => v!==undefined && v.length >= 8 || this.$t('min_8_caracters'),
                    match: v => v == this.password || this.$t('password_mismatch'),
                    email: v => (v.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) ||  this.$t('invalid_email'),
                    tel: v => (v.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s/0-9]*$/g)) ||  this.$t('invalid_phone'),
                    //email: v => (v.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) ||  this.$t('invalid_email'),
                },
            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? this.$t('transfert.new_transfert') : this.$t('transfert.update_transfert')
            },
            ...mapState('users/',['users']),
            ...mapState('transfers/',['transfers']),
            ...mapState('marchands/',['marchand']),
            ...mapState('generalsettings/',['generals','generalmarchands']),
            ...mapState('users/',['receiver']),


        },
        mounted(){
            this.$store.dispatch('users/getUsers').then(response=>{
                console.log('users',response)

            });
            let data2 = new FormData();
            data2.append("devise", this.$store.getters.auth.wallet.devise._id);

            this.$store.dispatch('generalsettings/getGeneralSettingForMarchandDevise',data2).then(response => {
                console.log('getGeneralSettingAdmin',response)
                this.generaldatas = response.generalsettings;

            });



            if(this.$store.getters.auth.wallet){
                console.log('wallet',this.$store.getters.auth.wallet);
                this.walle=this.$store.getters.auth.wallet._amount;

            }else{
                this.walle=0;
            }

            this.$store.dispatch('marchands/getMarchandOne').then(response => {
                console.log('marchand',response)
            });
            if (this.$store.getters.auth.role._code==='admin') {
                let datarec = {"type":'admin', "id":("?")};
                this.$store.dispatch('transfers/getTransfer',datarec).then(response => {
                    console.log('transfers', response)
                });

            }
            else{
                let datarec = {"type":'user', "id":(this.$store.getters.auth._id)};
                this.$store.dispatch('transfers/getTransfer',datarec).then(response => {
                        var transfers_envoye=[];
                        for (let i=0;i<response.data.transfers.length; i++) {
                            if(!response.data.transfers[i].sender_marchand){
                                if (response.data.transfers[i].sender_user._email===this.$store.getters.auth._email ) {
                                    let transfers_env=response.data.transfers[i];
                                    transfers_envoye.push(transfers_env);
                                }
                            }
                        }
                        console.log('transfers_envoyés',transfers_envoye)
                        this.transfers_envoyes=transfers_envoye;


                    console.log('transfers', response)
                });
            }




        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            initialize () {
                this.langues = [
                    {
                        name:'Bénin',
                        code_iso_alpha_2:'BJ',
                        code_iso_alpha_3:'BEN',
                        code_iso_numerique:204
                    }
                ];

            },
            editItem (item) {
                this.editedIndex = this.transfers.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true;
                this.id = item._id;
            },

            close () {
                this.dialog = false;
                this.$refs.form.reset();
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
            },
            categorieChanged(){
                this.categorieHasChanged = true;
            },

            suivant () {
                if (this.editedItem._recepteur){
                        this.$store.dispatch('users/getRecepteur',this.editedItem._recepteur).then(response => {
                            console.log('user',response);
                            if (this.receiver){
                                if (this.receiver._email===this.$store.getters.auth._email) {
                                    this.auth=true;
                                    this.recep="Vous ne pouvez pas effectué un transfert à vous même";
                                }
                                else{
                                    this.recep_first_name=this.receiver._first_name;
                                    this.recep_last_name=this.receiver._last_name;
                                    this.recep_email=this.receiver._email;
                                }


                            } else{
                                this.recep="Cet utulisateur n'existe pas dans notre base de donnée";
                                console.log("N'existe pas dans notre base de donnée",this.recep);

                            }
                        });
                }
                this.e1=2;



            },
            suivant1 () {
                if (this.editedItem._recepteur){
                        this.$store.dispatch('users/getRecepteur',this.editedItem._recepteur).then(response => {
                            console.log('user',response);
                            if (this.receiver){
                                this.recep_first_name=this.receiver._first_name;
                                this.recep_last_name=this.receiver._last_name;
                                this.recep_email=this.receiver._email;

                            } else{
                                this.recep="Cet utulisateur n'existe pas dans notre base de donnée";
                                console.log("N'existe pas dans notre base de donnée",this.recep);

                            }
                        });
                }
                this.e1=3;



            },
            setdefaultClose(){
                this.e1 = 1;
                this.step1=false;
                this.step2=false;
                this.step3=true;
                this.dialog = false;
            },
            save () {
                let VueBox = this;
                let data = new FormData();
                this.mis=true;
                data.append("amount",this.editedItem._montant);
                data.append("type","C_C");
                data.append("sender_id",this.$store.getters.auth._id);
                data.append("email",this.editedItem._recepteur);
                data.append("reason",this.editedItem._reason);
                if (this.id)
                    data.append("id",this.id);
                this.submitting = true;
                this.$store.dispatch('transfers/setTransfer',data).then((response)=>{
                    console.log('set transfer response',response)
                    this.submitting = false;
                    if (response.error){
                        this.errors.operation=response.message;
                    }else{

                        VueBox.$parent.resetDatas(VueBox);
                        this.close();
                        this.showSnackDefault(response);
                        if (this.$store.getters.auth.role._code==='admin') {
                            let datarec = {"type":'admin', "id":("?")};
                            this.$store.dispatch('transfers/getTransfer',datarec).then(response => {
                                console.log('transfers', response)
                            });

                        }
                        else{
                            let datarec = {"type":'user', "id":(this.$store.getters.auth._id)};
                            this.$store.dispatch('transfers/getTransfer',datarec).then(response => {
                                var transfers_envoye=[];
                                for (let i=0;i<response.data.transfers.length; i++) {
                                    if(!response.data.transfers[i].sender_marchand){
                                        if (response.data.transfers[i].sender_user._email===this.$store.getters.auth._email ) {
                                            let transfers_env=response.data.transfers[i];
                                            transfers_envoye.push(transfers_env);
                                        }
                                    }

                                }
                                console.log('transfers_envoyés',transfers_envoye);
                                this.transfers_envoyes=transfers_envoye;
                                console.log('transfers', response)
                            });
                        }

                    }
                })
            },
            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
            fileChange() {
                console.log( this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },

    }
</script>
<style scoped>
</style>
